import Draggable from "react-draggable";
import "../profile/LaterallCephalo/cephalo.css";
import { useEffect, useState } from "react";
import {
  Button,
  ConfigProvider,
  Descriptions,
  List,
  Radio,
  Segmented,
  Slider,
  Tag,
  message,
} from "antd";
import { BsFillPatchCheckFill } from "react-icons/bs";
import { PiCrosshairFill } from "react-icons/pi";
//redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../appRedux/actions/CoreServicesAction";
import { useNavigate, useParams } from "react-router-dom";


import Url from "../../apiCall/UrlConfig";
import LoadingComponent from "../../component/Loading";

import { HiMiniEye, HiMiniEyeSlash } from "react-icons/hi2";
import RangeAnalyses from "../../component/RangeAnalyses";

import {
  calculateSignedAngle,
  calculateAngle,
  calculateDistance,
  calculateAngleBetweenLines,
} from "../../component/utility";
const ImagePreAddress = Url.baseURL[0] + Url.dental_file_donwload;
const PublicLateralAnalyses = (props) => {
  let navigate = useNavigate();
  const { imgpath } = useParams();
  const [cephaloImageDimension, setCephaloImageDimension] = useState({
    width: 0,
    height: 0,
  });

  const [IsTracing, setTracing] = useState(null);

  const [ListAllPoints, setListAllPoints] = useState([
    "N",
    "S",
    "Or",
    "Me",
    "Go",
    "Gn",
    "Po",
    "PNS",
    "ANS",
    "A",
    "B",
    "POG",
    "Ar",
  ]);
  const [ListPoint, setListPoint] = useState([
    // {
    //   title: "N",
    //   x: 100,
    //   y: 200,
    //   isPredicted: false,
    //   isShow: true,
    // },
  ]);
  const [ListLines, setListLines] = useState([
    {
      title: "SN",
      startPoint: "S",
      endPoint: "N",
      isShow: true,
      color: "red",
    },
    {
      title: "NA",
      startPoint: "N",
      endPoint: "A",
      isShow: true,
      color: "red",
    },
    {
      title: "NB",
      startPoint: "N",
      endPoint: "B",
      isShow: true,
      color: "red",
    },
    {
      title: "Me-Go",
      startPoint: "Me",
      endPoint: "Go",
      isShow: true,
      color: "red",
    },
    {
      title: "S-Ar",
      startPoint: "S",
      endPoint: "Ar",
      isShow: true,
      color: "red",
    },
    {
      title: "Ar-Go",
      startPoint: "Ar",
      endPoint: "Go",
      isShow: true,
      color: "red",
    },

    {
      title: "ANS-PNS",
      startPoint: "ANS",
      endPoint: "PNS",
      isShow: true,
      color: "red",
    },

    {
      title: "occlusal plane",
      startPoint: "OP1",
      endPoint: "OP2",
      isShow: true,
      color: "red",
    },

    {
      title: "U Tooth",
      startPoint: "U1",
      endPoint: "U2",
      isShow: true,
      color: "red",
    },
    {
      title: "L Tooth",
      startPoint: "L1",
      endPoint: "L2",
      isShow: true,
      color: "red",
    },
    {
      title: "Frankford",
      startPoint: "Po",
      endPoint: "Or",
      isShow: true,
      color: "red",
    },
    {
      title: "S-Gn",
      startPoint: "S",
      endPoint: "Gn",
      isShow: true,
      color: "red",
    },
  ]);

  const [ListAngles, setListAngles] = useState([
    {
      type: "Skeletal",
      Axis: "A/P",
      title: "SNA",
      startPoint: "S",
      middlePoint: "N",
      endPoint: "A",
      isShow: true,
      color: "blue",
      marginPixelFromCenter: 20,
      LowerNormalValue: 78,
      UpperNormalValue: 84,
      marginValue: 8,
      AccualValue: 90,
      stepRuller: 1,
      AngledSign: false,
    },
    {
      type: "Skeletal",
      Axis: "A/P",
      title: "SNB",
      startPoint: "S",
      middlePoint: "N",
      endPoint: "B",
      isShow: true,
      color: "blue",
      marginPixelFromCenter: 20,
      LowerNormalValue: 75,
      UpperNormalValue: 81,
      marginValue: 10,
      AccualValue: 90,
      stepRuller: 1,
      AngledSign: false,
    },
    {
      type: "Skeletal",
      Axis: "A/P",
      title: "ANB",
      startPoint: "A",
      middlePoint: "N",
      endPoint: "B",
      isShow: true,
      color: "blue",
      marginPixelFromCenter: 20,
      LowerNormalValue: 2,
      UpperNormalValue: 4,
      marginValue: 4,
      AccualValue: 3.5,
      stepRuller: 1,
      AngledSign: true,
    },
    {
      type: "Skeletal",
      Axis: "A/P",
      title: "SN-POG",
      startPoint: "S",
      middlePoint: "N",
      endPoint: "POG",
      isShow: true,
      color: "blue",
      marginPixelFromCenter: 20,
      LowerNormalValue: 80,
      UpperNormalValue: 82,
      marginValue: 4,
      AccualValue: 3.5,
      stepRuller: 1,
      AngledSign: false,
    },
    {
      type: "Skeletal",
      Axis: "Vertical",
      title: "Y-axis",
      startPoint: "N",
      middlePoint: "S",
      endPoint: "Gn",
      isShow: true,
      color: "blue",
      marginPixelFromCenter: 20,
      LowerNormalValue: 65,
      UpperNormalValue: 67,
      marginValue: 5,
      AccualValue: 0,
      stepRuller: 1,
      AngledSign: false,
    },
    {
      type: "Skeletal",
      Axis: "Vertical",
      title: "Facial Angle",
      startPoint: "",
      middlePoint: "",
      endPoint: "",
      AngleLines: {
        Point1Line1: "Po",
        Point2Line1: "Or",
        Point1Line2: "N",
        Point2Line2: "POG",
      },
      isShow: true,
      color: "blue",
      marginPixelFromCenter: 20,
      LowerNormalValue: 82,
      UpperNormalValue: 95,
      marginValue: 6,
      AccualValue: 0,
      stepRuller: 1,
      AngledSign: false,
    },
    {
      type: "Skeletal",
      Axis: "Vertical",
      title: "saddle angle",
      startPoint: "Ar",
      middlePoint: "S",
      endPoint: "N",
      isShow: true,
      color: "blue",
      marginPixelFromCenter: 20,
      LowerNormalValue: 118,
      UpperNormalValue: 128,
      marginValue: 8,
      AccualValue: 3.5,
      stepRuller: 1,
      AngledSign: false,
    },
    {
      type: "Skeletal",
      Axis: "Vertical",
      title: "Articular angle",
      startPoint: "Go",
      middlePoint: "Ar",
      endPoint: "S",
      isShow: true,
      color: "blue",
      marginPixelFromCenter: 20,
      LowerNormalValue: 137,
      UpperNormalValue: 149,
      marginValue: 7,
      AccualValue: 3.5,
      stepRuller: 1,
      AngledSign: false,
    },
    {
      type: "Skeletal",
      Axis: "Vertical",
      title: "Gonial angle",
      startPoint: "Me",
      middlePoint: "Go",
      endPoint: "Ar",
      isShow: true,
      color: "blue",
      marginPixelFromCenter: 20,
      LowerNormalValue: 123,
      UpperNormalValue: 137,
      marginValue: 17,
      AccualValue: 3.5,
      stepRuller: 1,
      AngledSign: false,
    },
    {
      type: "Skeletal",
      Axis: "Vertical",
      title: "Basal angle",
      startPoint: "",
      middlePoint: "",
      endPoint: "",
      AngleLines: {
        Point1Line1: "PNS",
        Point2Line1: "ANS",
        Point1Line2: "Go",
        Point2Line2: "Me",
      },
      isShow: true,
      color: "blue",
      marginPixelFromCenter: 20,
      LowerNormalValue: 23,
      UpperNormalValue: 27,
      marginValue: 6,
      AccualValue: 3.5,
      stepRuller: 1,
      AngledSign: false,
    },
    {
      type: "Skeletal",
      Axis: "Vertical",
      title: "SN-Me Go angle",
      startPoint: "",
      middlePoint: "",
      endPoint: "",
      AngleLines: {
        Point1Line1: "S",
        Point2Line1: "N",
        Point1Line2: "Go",
        Point2Line2: "Me",
      },
      isShow: true,
      color: "blue",
      marginPixelFromCenter: 20,
      LowerNormalValue: 32,
      UpperNormalValue: 36,
      marginValue: 6,
      AccualValue: 3.5,
      stepRuller: 1,
      AngledSign: false,
    },
    {
      type: "Skeletal",
      Axis: "Vertical",
      title: "Cant of occlusal plane",
      startPoint: "",
      middlePoint: "",
      endPoint: "",
      AngleLines: {
        Point1Line1: "OP1",
        Point2Line1: "OP2",
        Point1Line2: "Go",
        Point2Line2: "Me",
      },
      isShow: true,
      color: "blue",
      marginPixelFromCenter: 20,
      LowerNormalValue: 12,
      UpperNormalValue: 14,
      marginValue: 6,
      AccualValue: 3.5,
      stepRuller: 1,
      AngledSign: false,
    },
    {
      type: "Skeletal",
      Axis: "Vertical",
      title: "FMA",
      startPoint: "",
      middlePoint: "",
      endPoint: "",
      AngleLines: {
        Point1Line1: "Po",
        Point2Line1: "Or",
        Point1Line2: "Go",
        Point2Line2: "Me",
      },
      isShow: true,
      color: "blue",
      marginPixelFromCenter: 20,
      LowerNormalValue: 23,
      UpperNormalValue: 27,
      marginValue: 6,
      AccualValue: 3.5,
      stepRuller: 1,
      AngledSign: false,
    },
  ]);

  const [loadingModal, setLoadingModal] = useState(true);

  const [showAllpoint, setShowAllpoint] = useState(true);

  const [_scale, setScale] = useState(1);

  const MaxImageWidth = 400;


  const _getCephaloPrediction = async (scale) => {
    // return;
    if (scale == null) {
      scale = _scale;
    }
    let url = Url.GetPointWithAi + imgpath;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    if (res.hasError) {
      message.error(res.message);
      return;
    }

    let JsonParse = JSON.parse(res.data);

    let ListPointFromAi = [];
    JsonParse.forEach((element) => {
      ListPointFromAi.push({
        title: element.name,
        x: element.x * scale,
        y: element.y * scale,
        isPredicted: true,
        isShow: true,
      });

      if (element.name == "OP2") {
        let APoint = JsonParse.find((o) => o.name == "A");
        let U2 = JsonParse.find((o) => o.name == "U2");
        if (APoint && U2) {
          let AtoU2Distance = calculateDistance(APoint, U2);
          ListPointFromAi.push({
            title: "U1",
            x: (element.x + AtoU2Distance / 2) * scale,
            y: element.y * scale,
            isPredicted: true,
            isShow: true,
          });
          ListPointFromAi.push({
            title: "L1",
            x: (element.x - AtoU2Distance / 4) * scale,
            y: element.y * scale,
            isPredicted: true,
            isShow: true,
          });
        }
      }
    });
    setListPoint(ListPointFromAi);
  };

  const [ResultRadioGroup, setResultRadioGroup] = useState("List_Point");
  const _returnDragablePoints = () => {
    const onStop = (event, data, key) => {
      let newList = [...ListPoint];
      let index = ListPoint.findIndex((o) => o.title == key);
      newList[index] = { ...newList[index], x: data.x, y: data.y };
      console.log(data);
      setListPoint(newList);
    };
    let _outPut = [];

    ListPoint.forEach((element) => {
      if (!element.isShow) {
        return;
      }
      _outPut.push(
        <Draggable
          key={element.title}
          bounds="parent"
          position={{ x: element.x, y: element.y }}
          defaultPosition={{ x: element.x, y: element.y }}
          onStop={(event, data, key) => onStop(event, data, element.title)}
        >
          <div className="cephalo_dragable_container">
            <div className="cephalo-circlePoint" />
            <div className="cephalo_dragable_tile">{element.title}</div>
          </div>
        </Draggable>
      );
    });

    return _outPut;
  };

  const _returnRadioView = () => {
    switch (ResultRadioGroup) {
      case "List_Point":
        return _returnListPointView();
      case "Analyses":
        return _returnAnalysesView();

      default:
        break;
    }
  };

  const _returnAnalysesView = () => {
    const _renderSkeletal = (item, index) => {
      let startPointObj = ListPoint.find((o) => o.title == item.startPoint);
      let middlePointObj = ListPoint.find((o) => o.title == item.middlePoint);
      let endPointObj = ListPoint.find((o) => o.title == item.endPoint);

      let ISAllPointAvvilable = false;
      let _item = { ...item };
      if (startPointObj && middlePointObj && endPointObj) {
        ISAllPointAvvilable = true;
        _item.AccualValue = calculateAngle(
          startPointObj,
          middlePointObj,
          endPointObj
        ).toFixed(2);

        if (_item.AngledSign) {
          _item.AccualValue = calculateSignedAngle(
            startPointObj,
            middlePointObj,
            endPointObj
          ).toFixed(2);
        }
      }

      if (_item.AngleLines) {
        let Point1Line1 = ListPoint.find(
          (o) => o.title == _item?.AngleLines?.Point1Line1
        );
        let Point2Line1 = ListPoint.find(
          (o) => o.title == _item?.AngleLines?.Point2Line1
        );
        let Point1Line2 = ListPoint.find(
          (o) => o.title == _item?.AngleLines?.Point1Line2
        );
        let Point2Line2 = ListPoint.find(
          (o) => o.title == _item?.AngleLines?.Point2Line2
        );

        if (Point1Line1 && Point2Line1 && Point1Line2 && Point2Line2) {
          ISAllPointAvvilable = true;
          _item.AccualValue = calculateAngleBetweenLines(
            Point1Line1,
            Point2Line1,
            Point1Line2,
            Point2Line2
          ).toFixed(2);
        }
      }

      let color = "red";
      if (
        _item.AccualValue >= _item.LowerNormalValue &&
        _item.AccualValue <= _item.UpperNormalValue
      ) {
        color = "green";
      }
      return (
        <div className="Container_row_angels ">
          <div className="align-center" style={{ width: "130px" }}>
            {item.title}
          </div>
          <div style={{ width: "140px" }}>
            <div>
              {ISAllPointAvvilable ? <RangeAnalyses item={_item} /> : <></>}
            </div>
          </div>
          <div
            className="align-center"
            style={{ width: "140px", marginLeft: 30 }}
          >
            <div>
              value = <span style={{ color: color }}>{_item.AccualValue}</span>
            </div>
          </div>
        </div>
      );
    };
    return (
      <div>
        <div className="ListPointContainer">
          <div className=" flex-row  marginSTitle">
            <div>SKELETAL </div>
          </div>
          <div className="ContainerlistSkelatAnalyses">
            <List dataSource={ListAngles} renderItem={_renderSkeletal} />
          </div>
        </div>
      </div>
    );
  };
  const _returnListPointView = () => {
    const _renderItem = (item, index) => {
      let isThisItemTracing = IsTracing == item ? true : false;
      let ItemFound = ListPoint.find((o) => o.title == item);
      let isItemFound = ItemFound == null ? false : true;

      let crosshairCss = "tracebutton";
      if (isThisItemTracing) crosshairCss = "tracebutton IsTracingButtonBlink";

      const _onItemSigleShow = (show) => {
        let newList = [...ListPoint];
        let index = ListPoint.findIndex((o) => o.title == item);
        newList[index] = { ...newList[index], isShow: show };
        setListPoint(newList);
      };
      return (
        <div>
          <div className="ItemListPoint">
            <div className="itemListPointTitle">{item}</div>
            <div className="itemListPointTitle text-center">
              {isItemFound ? (
                <BsFillPatchCheckFill color="#87d068" />
              ) : (
                <div>
                  <PiCrosshairFill
                    onClick={() => setTracing(item)}
                    className={crosshairCss}
                  />
                </div>
              )}
            </div>
            <div className="itemListPointTitle ">
              {ItemFound?.isShow ? (
                <HiMiniEye
                  onClick={() => _onItemSigleShow(false)}
                  color="grey"
                />
              ) : (
                <div>
                  {ItemFound == null ? (
                    <div />
                  ) : (
                    <HiMiniEyeSlash
                      onClick={() => _onItemSigleShow(true)}
                      color="grey"
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      );
    };

    const _renderItemLines = (item, index) => {
      let startPointObj = ListPoint.find((o) => o.title == item.startPoint);
      let endPointObj = ListPoint.find((o) => o.title == item.endPoint);

      let IsLineComplete = false;
      if (endPointObj && startPointObj) {
        IsLineComplete = true;
      }

      return (
        <div>
          <div className="ItemListPoint">
            <div className="itemListPointTitleLines">{item.title}</div>
            <div className="itemListPointTitle ">
              {IsLineComplete ? (
                <BsFillPatchCheckFill color="#87d068" />
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
      );
    };

    const _onShowAllPoint = (show) => {
      setShowAllpoint(show);
      let newList = [...ListPoint];
      for (let index = 0; index < newList.length; index++) {
        newList[index].isShow = show;
      }
      setListPoint(newList);
    };
    return (
      <div className="">
        <div className="ListPointContainer">
          <div className=" flex-row  marginSTitle">
            <div>List Point</div>
            <div className="align-center" style={{ marginLeft: 45 }}>
              {showAllpoint ? (
                <HiMiniEye onClick={() => _onShowAllPoint(false)} />
              ) : (
                <HiMiniEyeSlash onClick={() => _onShowAllPoint(true)} />
              )}
            </div>
          </div>
          <List dataSource={ListAllPoints} renderItem={_renderItem} />
        </div>
        <div className="ListPointContainer">
          <div className=" flex-row  marginSTitle">List Lines</div>
          <List dataSource={ListLines} renderItem={_renderItemLines} />
        </div>
      </div>
    );
  };

  const _onClickImageDuringTracing = (e) => {
    if (IsTracing == null) {
      return;
    }
    let newList = [...ListPoint];
    newList.push({
      title: IsTracing,
      x: e.nativeEvent.offsetX,
      y: e.nativeEvent.offsetY,
      isPredicted: false,
      isShow: true,
    });
    setListPoint(newList);

    setTracing(null);
  };

  const OnLoadImage = (e) => {
    let _Width = e.target.width;
    let _height = e.target.height;
    let scale = _scale;
    if (e.target.width > MaxImageWidth) {
      scale = MaxImageWidth / e.target.width;
      setScale(scale);
      _Width = MaxImageWidth;
      _height = e.target.height * (MaxImageWidth / e.target.width);
    }

    _getCephaloPrediction(scale);

    setCephaloImageDimension({
      width: _Width,
      height: _height,
    });
  };

  const _returnSvgElemnt = () => {
    let _outPut = [];

    ListLines.forEach((element) => {
      let startPointObj = ListPoint.find((o) => o.title == element.startPoint);
      let endPointObj = ListPoint.find((o) => o.title == element.endPoint);

      if (startPointObj && endPointObj && element.isShow) {
        _outPut.push(
          <line
            x1={startPointObj.x}
            y1={startPointObj.y}
            x2={endPointObj.x}
            y2={endPointObj.y}
            stroke="red"
            strokeWidth="0.8"
          />
        );
      }
    });

    return _outPut;
  };

  let imageCss = "imageCephalo";
  let svgCss = "svgContainer ";
  if (IsTracing) {
    imageCss = "imageCephalo IsTracing";
    svgCss = "svgContainer IsTracing";
  }

  return (
    <ConfigProvider direction="ltr">
      <div dir="ltr">
        <LoadingComponent
          isLoading={
            props.coreData[Url.GetPointWithAi + imgpath]?.[Url.action]
              ?.isFetching
          }
        />
        <div className="cephalo_page_container">
          <div
            className="chephaloContainer"
            style={{
              width: cephaloImageDimension.width,
              height: cephaloImageDimension.height,
              minWidth: cephaloImageDimension.width,
            }}
          >
            <img /////for get dimentions not display
              style={{ display: "none" }}
              src={ImagePreAddress + imgpath}
              onLoad={OnLoadImage}
            />
            <img
              className={imageCss}
              src={ImagePreAddress + imgpath}
              style={{
                width: cephaloImageDimension.width,
                height: cephaloImageDimension.height,
              }}
            />
 
            <svg
              className={svgCss}
              width={cephaloImageDimension.width}
              height={cephaloImageDimension.height}
              xmlns="http://www.w3.org/2000/svg"
              onClick={_onClickImageDuringTracing}
            >
              {_returnSvgElemnt()}
            </svg>
            {_returnDragablePoints()}
          </div>
          <div className="chephalo_result_container">
            <div className="cephalo_title marginTitle">
              Cephalometric Analysis
            </div>
            <div className="marginTitle RadioContainer RadioButton">
              <Segmented
                onChange={(e) => setResultRadioGroup(e)}
                defaultValue="List_Point"
                size="large"
                options={[
                  { label: "List Point", value: "List_Point" },
                  { label: "Analyses", value: "Analyses" },
                  { label: "Chart", value: "Chart" },
                ]}
              />

              {_returnRadioView()}
            </div>
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublicLateralAnalyses);
